/* eslint-disable class-methods-use-this */
import AdException from '../../errors/ad.exception';
import DisplayPlayerListeners from './display.player.listeners';

export default class DisplayPlayerController {
  constructor(itemContent, cid) {
    this.itemContent = itemContent || 0;
    this.cid = cid || 0;
    this.idComponent = 0;
    this.duration = 10;
  }

  getPlayerHTML() {}

  insert(divId) {
    // eslint-disable-next-line no-undef
    this.divSlot = document.getElementById(divId);
    if (!this.divSlot) return;
    try {
      this.divSlot.style.scale =
        this.divSlot.closest('.video-ext-container').parentElement.parentElement.clientWidth > 320
          ? 1
          : this.divSlot.closest('.video-ext-container').parentElement.parentElement.clientWidth /
            320;
      if (this.divSlot.style.scale < 1) {
        this.divSlot.style.top = '0px';
        this.divSlot.style.transform = 'unset';
      }
    } catch (error) {
      this.divSlot.style.scale = 1;
    }

    if (this.divSlot !== '' && !this.handler) {
      this.handler = new DisplayPlayerListeners(this.idComponent, this.duration, this.divSlot);
    }
  }

  load() {
    if (!this.handler)
      this.handler = new DisplayPlayerListeners(this.idComponent, this.duration, this.divSlot);

    return new Promise((resolve, reject) => {
      if (this.divSlot) {
        resolve('player loaded');
      } else {
        reject(new AdException('there is not divid Slot to show display ad', '010'));
      }
    });
  }

  remove() {
    this.handler.remove();
  }

  play() {
    this.handler.start();
  }

  pause() {
    this.handler.pause();
  }

  resume() {
    this.handler.pause();
  }

  getVolume() {}

  setVolume() {}

  mute() {}

  mutePP() {}

  unmute() {}

  getDuration() {
    return this.handler.duration;
  }

  getCurrentTime() {
    return this.handler.currentTime;
  }

  isMetadataLoaded() {
    return this.code !== '';
  }

  showControls() {}

  setAutoPlay() {}

  seekTo() {}

  getEvent() {
    return this.handler.displayPlayerEvent;
  }

  start() {
    this.handler.start();
  }

  paused() {
    return this.handler.state === 'pause';
  }

  resize() {}
}
